module.exports = __webpack_public_path__ + "img/Sekhukhune-united.0d0512c8.png";